import script from "./SizeChartForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SizeChartForm.vue?vue&type=script&setup=true&lang=js"

import "./SizeChartForm.vue?vue&type=style&index=0&id=22a49cb3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a49cb3"]])

export default __exports__